import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Checkbox, Form, Input, InputNumber, Select, Switch } from 'antd';


import REDUX_VidiUslugNaMeropriyatii from '../../../objects/VidiUslugNaMeropriyatii/reducer'
import CRUDE_VidiUslugNaMeropriyatii from '../../../objects/VidiUslugNaMeropriyatii/crude'

import REDUX_TipiTarifov from '../../../objects/TipiTarifov/reducer'
import CRUDE_TipiTarifov from '../../../objects/TipiTarifov/crude'

import REDUX_StatusiPokupatelya from '../../../objects/StatusiPokupatelya/reducer'
import CRUDE_StatusiPokupatelya from '../../../objects/StatusiPokupatelya/crude'

import EmojiTextArea from '../../../common/EmojiTextArea';

const { Option } = Select;

export default function NovieUslugiNaMeropriyatii(props) {
    const { auth, object, form, sourceKey } = props;
    const dispatch = useDispatch();

    const vidiUslugNaMeropriyatii = useSelector(REDUX_VidiUslugNaMeropriyatii.selector.arrayByKey(sourceKey));
    const tipiTarifov = useSelector(REDUX_TipiTarifov.selector.arrayByKey(sourceKey));
    useEffect(() => {
        form.resetFields();
        CRUDE_VidiUslugNaMeropriyatii.read(auth, (data) => {
            if (data.length > 0) {
                dispatch(REDUX_VidiUslugNaMeropriyatii.actions.setArrayByKey(sourceKey, data));
            }
        }, 'model', 's-id=ASC');

        CRUDE_TipiTarifov.read(auth, (data) => {
            if (data.length > 0) {
                dispatch(REDUX_TipiTarifov.actions.setArrayByKey(sourceKey, data));
            }
        }, 'model', 's-id=ASC');

        CRUDE_StatusiPokupatelya.read(auth, (data) => {
            if (data.length > 0) {
                dispatch(REDUX_StatusiPokupatelya.actions.setArrayByKey(sourceKey, data));
            }
        }, 'model', 's-id=ASC');

    }, []);

    const vidiUslugNaMeropriyatiiOptions = vidiUslugNaMeropriyatii.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);
    const tipiTarifovOptions = tipiTarifov.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <Form.Item label="Название услуги"
                    name="nazvanie"
                    rules={[{ required: true, message: 'Пожалуйста, укажите название!' }]}
                >
                    <Input />
                </Form.Item>
                <div style={{ marginTop: "20px" }}>
                    <Form.Item label="Описание услуги (располагается выше сетки цен)"
                        tooltip="На странице мероприятия в блоке услуги это описание располагается выше сетки цен."
                        name="opisanie"
                        rules={[{ required: false, message: 'Пожалуйста, укажите описание!' }]}
                    >
                        <EmojiTextArea rows={8} />
                    </Form.Item>
                </div>
                <div style={{ marginTop: "10px" }}>
                    <Form.Item label="Описание услуги (располагается ниже сетки цен)"
                        tooltip="На странице мероприятия в блоке услуги это описание располагается ниже сетки цен."
                        name="priceText"
                        rules={[{ required: false, message: 'Пожалуйста, укажите текст в ценах!' }]}
                    >
                        <EmojiTextArea rows={8} />
                    </Form.Item>
                </div>
                <Form.Item label="Вид услуги"
                    name="vidUslugiID"
                    rules={[{ required: true, message: 'Пожалуйста, укажите вид услуги!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {vidiUslugNaMeropriyatiiOptions}
                    </Select>
                </Form.Item>
                <Form.Item label="Тип тарифа"
                    name="tipTarifaID"
                    rules={[{ required: true, message: 'Пожалуйста, укажите tип тарифа!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {tipiTarifovOptions}
                    </Select>
                </Form.Item>
                <Form.Item
                    name={"sort"}
                    label={"Порядок сортировки"}
                    rules={[{ required: false, message: 'Укажите необходимый кворум!' }]}
                >
                    <InputNumber precision={0} style={{ width: "150px" }} />
                </Form.Item>
                <Form.Item
                    name="vklyuchitKommentarii"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Включить комментарий покупателя
                    </Checkbox>
                </Form.Item>
                {/* <Form.Item label="Статус покупателя"
                    name="statusPokupatelyaID"
                    rules={[{ required: false, message: 'Пожалуйста, укажите статус покупателя!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {statusiPokupatelyaOptions}
                    </Select>
                </Form.Item> */}
            </Form>
        </>
    );
}
